/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class DashboardComponentType.
* @enum {}
* @readonly
*/
export default class DashboardComponentType {
        /**
         * value: "CompanySummary"
         * @const
         */
        CompanySummary = "CompanySummary";

        /**
         * value: "Delivery"
         * @const
         */
        Delivery = "Delivery";


    /**
    * Returns a <code>DashboardComponentType</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/DashboardComponentType} The enum <code>DashboardComponentType</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}
